export default function (Alpine) {
    Alpine.data("customization", function (data, scope = {}) {
        let onModalOpened
        let onModalClosed

        return {
            ...scope,

            isEditing: false,
            isEditingWithCustomization: false,
            optionRatesInCents: {},
            defaultBlade: null,
            blade: null,
            engraving: null,
            bladeText: null,
            springText: null,
            boxText: null,
            bee: null,
            bladeEngravings: [],
            springEngravings: [],
            boxEngravings: [],
            bladesCompatibleWithBladeEngraving: [],

            // Merge data from html over properties declared above
            ...data,

            init() {
                this.isEditingWithCustomization = this.isCustomized()
            },

            resetCustomization() {
                this.blade = this.defaultBlade

                this.engraving =
                    this.bladeText =
                    this.springText =
                    this.bee =
                        null

                this.isEditing = false
                this.isEditingWithCustomization = false

                return true
            },

            saveCustomization() {
                if (this.showEngravingTextError()) {
                    return false
                }

                return true
            },

            canEngraveBlade() {
                return (
                    this.bladesCompatibleWithBladeEngraving.indexOf(
                        this.blade
                    ) !== -1
                )
            },

            removeCustomizationIdFromUrl() {
                try {
                    let url = new URL(window.location)
                    url.searchParams.delete("customization")
                    window.history.replaceState({}, "", url.toString())
                } catch (e) {}
            },

            computeCustomizationTotalInCents() {
                let total = 0
                if (this.blade) {
                    // Price can be undefined if blade is not customizable
                    total += this.optionRatesInCents[this.blade] || 0
                }
                if (this.engraving) {
                    total += this.optionRatesInCents[this.engraving]
                }
                if (this.bee) {
                    total += this.optionRatesInCents[this.bee]
                }
                return total
            },

            isCustomized() {
                return (
                    (this.blade && this.blade !== this.defaultBlade) ||
                    this.engraving ||
                    this.bee
                )
            },

            isEngravingBlade() {
                return this.bladeEngravings.indexOf(this.engraving) !== -1
            },

            isEngravingSpring() {
                return this.springEngravings.indexOf(this.engraving) !== -1
            },

            isEngravingBox() {
                return this.boxEngravings.indexOf(this.engraving) !== -1
            },

            firstSpringEngraveOnly() {
                return (
                    this.springEngravings.find(
                        (item) => !this.bladeEngravings.includes(item)
                    ) || null
                )
            },

            isComplexCustomization() {
                if (this.isEngravingSpring()) {
                    return true
                }

                if (this.blade && this.blade !== this.defaultBlade) {
                    return true
                }

                if (this.bee) {
                    return true
                }

                return false
            },

            showEngravingTextError() {
                if (
                    this.isEngravingBlade() &&
                    this.canEngraveBlade() &&
                    !this.bladeText
                ) {
                    return true
                }

                if (this.isEngravingSpring() && !this.springText) {
                    return true
                }

                if (this.isEngravingBox() && !this.boxText) {
                    return true
                }

                return false
            },

            addToCartButtonLabel() {
                if (this.isCustomized()) {
                    if (this.isEditing) {
                        return this.isEditingWithCustomization
                            ? "Modifier la personnalisation"
                            : "Ajouter la personnalisation<br>au produit"
                    } else {
                        return "Ajouter le produit personnalisé<br>au panier"
                    }
                }

                if (this.isEditing) {
                    return this.isEditingWithCustomization
                        ? "Modifier et supprimer la personnalisation"
                        : "Modifier le produit sans le personnaliser"
                } else {
                    return "Ajouter au panier"
                }
            },
        }
    })
}
